const initialState = {
    campaignList: null,
    campaign: {},
    initialCall: true,
    lastKey: undefined
};

const campaignReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'RESET_CAMPAIGNS_STORE': {
            return initialState
        }
        case 'SET_CAMPAIGNS': {
            return {
                ...state,
                campaignList: action.payload.campaigns,
                initialCall: action.payload.initialCall,
                lastKey: action.payload.lastKey
            }
        }
        case 'SET_CAMPAIGN': {
            return {
                ...state,
                campaign: action.payload
            }
        }
        case 'SET_CAMPAIGN_INFO': {
            return {
                ...state,
                campaign: {
                    ...state.campaign,
                    [action.payload.key]: action.payload.value
                }
            }
        }
        default: {
            return state;
        }
    }
};

export default campaignReducer;